//* Libraries imports
import { useState, useCallback } from "react";

//* Service imports
import { techinicalHistoryService } from "@/features/techinicaldocument/TechinicalHistoryService";

//* Types imports
import type { ApiError } from "@/types/api";
import type {
  TechinicalHistoryOutputDTO,
  TechinicalHistoryFilters,
} from "@/features/techinicaldocument/types";

export const useFetchTechinicalHistory = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [items, setItems] = useState<TechinicalHistoryOutputDTO[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [item, setItem] = useState<TechinicalHistoryOutputDTO | null>(null);

  const fetchAll = useCallback(
    async (filters: TechinicalHistoryFilters = {}) => {
      setLoading(true);
      setError(null);
      try {
        const response = await techinicalHistoryService.list(filters);

        if ("code" in response && "message" in response) {
          const apiError = response as ApiError;
          throw new Error(apiError.message);
        }

        if ("data" in response && response.data) {
          setItems(response.data || []);
          setTotal(response.data.total || 0);
          return response.data;
        }
      } catch (err: any) {
        const errorMessage =
          err.message || "Ocorreu um erro ao buscar o histórico técnico";
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const fetchById = useCallback(async (id: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await techinicalHistoryService.fetchById(id);

      if ("code" in response && "message" in response) {
        const apiError = response as ApiError;
        throw new Error(apiError.message);
      }

      if ("data" in response) {
        setItem(response.data || null);
        return response.data;
      }
    } catch (err: any) {
      const errorMessage =
        err.message || "Ocorreu um erro ao buscar o detalhe do histórico";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  return { fetchAll, fetchById, items, total, item, loading, error };
};
